import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { exigir } from '../../nucleo/autorizacion/guardian.js';
import { rutaOperacion } from '../_operacion.js';

/**
 * El resumen de las noches: una, la semana o el mes. Con guardián propio, como la reapertura: el
 * grupo deja entrar al operario y `rep.noches` sólo contesta al jefe, la contadora y el
 * administrador, porque el traslado va a la caja de ahorro, que es de nivel 2.
 *
 * ponytail: la contadora no entra a `_operacion`, así que no llega a esta pantalla aunque la base
 * le conteste; si la pide, se monta la misma página también en `_contabilidad`.
 */
export const rutaNoches = createRoute({
  getParentRoute: () => rutaOperacion,
  path: '/jornada/noches',
  beforeLoad: ({ context }) => ({ sesion: exigir(context, { accion: 'jornada.reabrir' }) }),
  component: lazyRouteComponent(() => import('../../funcionalidades/noches/PaginaNoches.js'), 'PaginaNoches'),
});
